import { render, staticRenderFns } from "./flat-main.vue?vue&type=template&id=c28714f4&"
import script from "./flat-main.vue?vue&type=script&lang=js&"
export * from "./flat-main.vue?vue&type=script&lang=js&"
import style0 from "./flat-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports